import React from 'react';

interface IconProps {
  className?: string;
  style?: React.CSSProperties;
}

export const InfoIcon: React.FC<IconProps> = ({ className, style }) => (
  <svg
    viewBox="0 0 20 20"
    width="1em"
    height="1em"
    fill="none"
    className={className}
    style={style}
  >
    <circle cx="10"
      cy="10"
      r="7.91667"
      stroke="currentColor"
      strokeWidth="1.66667"
    />
    <path d="M9.01313 14.0625C9.01313 14.4077 9.29295 14.6875 9.63813 14.6875H10.3618C10.707 14.6875 10.9868 14.4077 10.9868 14.0625L10.9868 9.39145C10.9868 9.04627 10.707 8.76645 10.3618 8.76645H9.63813C9.29295 8.76645 9.01313 9.04627 9.01313 9.39145L9.01313 14.0625Z" fill="currentColor" />
    <path d="M9.01313 6.66119C9.01313 7.00636 9.29295 7.28618 9.63813 7.28618H10.3618C10.707 7.28618 10.9868 7.00636 10.9868 6.66118L10.9868 5.9375C10.9868 5.59232 10.707 5.3125 10.3618 5.3125L9.63813 5.3125C9.29295 5.3125 9.01313 5.59232 9.01313 5.9375L9.01313 6.66119Z" fill="currentColor" />
  </svg>
);

export const SuccessIcon: React.FC<IconProps> = ({ className, style }) => (
  <svg
    viewBox="0 0 20 20"
    width="1em"
    height="1em"
    fill="none"
    className={className}
    style={style}
  >
    <path d="M14.842 8.03505C15.0788 7.79829 15.0788 7.41444 14.842 7.17768L14.5562 6.89189C14.3195 6.65514 13.9356 6.65514 13.6989 6.89189L8.60774 11.9828L5.93571 9.3104C5.69896 9.07364 5.3151 9.07364 5.07834 9.3104L4.79256 9.59619C4.5558 9.83294 4.5558 10.2168 4.79256 10.4536L8.17915 13.8405C8.41591 14.0773 8.79976 14.0773 9.03652 13.8405L9.32231 13.5548C9.32533 13.5517 9.32832 13.5487 9.33126 13.5456L14.842 8.03505Z" fill="currentColor" />
    <circle cx="10"
      cy="10"
      r="7.91667"
      stroke="currentColor"
      strokeWidth="1.66667"
    />
  </svg>
);

export const ErrorIcon: React.FC<IconProps> = ({ className, style }) => (
  <svg
    viewBox="0 0 20 20"
    width="1em"
    height="1em"
    fill="none"
    className={className}
    style={style}
  >
    <path d="M10.9875 5.9375C10.9875 5.59232 10.7077 5.3125 10.3625 5.3125H9.63879C9.29362 5.3125 9.01379 5.59232 9.01379 5.9375L9.01379 10.6086C9.01379 10.9537 9.29362 11.2336 9.63879 11.2336H10.3625C10.7077 11.2336 10.9875 10.9537 10.9875 10.6086L10.9875 5.9375Z" fill="currentColor" />
    <path d="M10.9875 13.3388C10.9875 12.9936 10.7077 12.7138 10.3625 12.7138H9.63879C9.29362 12.7138 9.01379 12.9936 9.01379 13.3388L9.01379 14.0625C9.01379 14.4077 9.29362 14.6875 9.63879 14.6875H10.3625C10.7077 14.6875 10.9875 14.4077 10.9875 14.0625V13.3388Z" fill="currentColor" />
    <circle cx="10"
      cy="10"
      r="7.91667"
      stroke="currentColor"
      strokeWidth="1.66667"
    />
  </svg>
);

export const WarningIcon: React.FC<IconProps> = ({ className, style }) => (
  <svg
    viewBox="0 0 20 20"
    width="1em"
    height="1em"
    fill="none"
    className={className}
    style={style}
  >
    <path d="M10.7504 7.6C10.7504 7.33766 10.5378 7.125 10.2754 7.125H9.72543C9.46309 7.125 9.25043 7.33766 9.25043 7.6V11.15C9.25043 11.4123 9.4631 11.625 9.72543 11.625H10.2754C10.5378 11.625 10.7504 11.4123 10.7504 11.15V7.6Z" fill="currentColor" />
    <path d="M10.7504 13.225C10.7504 12.9627 10.5378 12.75 10.2754 12.75H9.72543C9.46309 12.75 9.25043 12.9627 9.25043 13.225V13.775C9.25043 14.0373 9.4631 14.25 9.72543 14.25H10.2754C10.5378 14.25 10.7504 14.0373 10.7504 13.775V13.225Z" fill="currentColor" />
    <path d="M17.9254 16.0068H2.08851L10.0065 2.29102L17.9254 16.0068Z"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinejoin="round"
    />
  </svg>
);

export const LoadingIcon: React.FC<IconProps> = ({ className, style }) => (
  <svg
    viewBox="0 0 1024 1024"
    width="1em"
    height="1em"
    fill="currentColor"
    className={`message-icon-loading ${className || ''}`}
    style={style}
  >
    <path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z" />
  </svg>
);

export const CloseIcon: React.FC<IconProps> = ({ className, style }) => (
  <svg
    viewBox="0 0 20 20"
    width="1em"
    height="1em"
    fill="none"
    className={className}
    style={style}
  >
    <path d="M5.30073 4.97637C5.54483 4.73252 5.94062 4.73237 6.18462 4.97637L10.0295 8.82126L13.8447 5.00606C14.0888 4.76201 14.4845 4.76199 14.7286 5.00606L15.0235 5.30092C15.2673 5.545 15.2674 5.9408 15.0235 6.1848L11.2083 10L15.0235 13.8152C15.2674 14.0592 15.2673 14.455 15.0235 14.6991L14.7286 14.9939C14.4845 15.238 14.0888 15.238 13.8447 14.9939L10.0295 11.1787L6.18462 15.0236C5.94062 15.2676 5.54483 15.2675 5.30073 15.0236L5.00588 14.7288C4.7618 14.4847 4.7618 14.089 5.00588 13.8449L8.85077 10L5.00588 6.15511C4.7618 5.91103 4.7618 5.5153 5.00588 5.27122L5.30073 4.97637Z" fill="currentColor" />
  </svg>
);
